<template>
  <div class="m">
    <NavBar />
    <div class="m-main">
      <h4 v-if="active==='qzgh'" class="page-header">{{ $t('mobile.careerInsights') }}</h4>
      <h4 v-if="active==='event'" class="page-header">{{ $t('mobile.latestEvents') }}</h4>
      <h4 v-if="active==='sxhjyjh'" class="page-header">{{ $t('mobile.careerOpportunities') }}</h4>
      <h4 v-if="active==='xygs'" class="page-header">{{ $t('mobile.peerStories') }}</h4>
      <h4 v-if="active==='xyds'" class="page-header">{{ $t('mobile.campusAmbassador') }}</h4>
      <h4 v-if="active==='tzy'" class="page-header">{{ $t('mobile.internshipChallenge') }}</h4>
      <ArticleTabs :active="active" :list="tabData" />
    </div>
  </div>
</template>

<script>
import { common } from './common/mixin.js'
import NavBar from './NavBar'
import ArticleTabs from './ArticleTabs'

const zhCatTypes = {
  qzgh: [{
    label: '观点',
    name: '010001'
  },
  {
    label: '大咖',
    name: '010002'
  },
  {
    label: '私货',
    name: '010003'
  }],
  event: [{
    of: 'event',
    label: '最新活动',
    name: 'event'
  // },
  // {
  //   label: '职场前沿',
  //   name: '020001'
  }],
  sxhjyjh: [
    {
      label: '实习和就业机会',
      name: '030001'
    }
  ],
  xygs: [
    {
      name: '040001',
      label: '归国迷茫'
    },
    {
      name: '040002',
      label: '背景提升'
    },
    {
      name: '040003',
      label: '成功转型'
    }
  ],
  xyds: [
    {
      name: '050001',
      label: '校园大使'
    }
  ],
  tzy: [
    {
      name: '060001',
      label: '挑战营'
    }
  ]
}

const enCatTypes = {
  qzgh: [{
    label: 'Viewpoint',
    name: '010001'
  },
  {
    label: 'Influencers',
    name: '010002'
  },
  {
    label: 'Exclusive',
    name: '010003'
  }],
  event: [{
    of: 'event',
    label: 'Latest Events',
    name: 'event'
  // },
  // {
  //   label: '职场前沿',
  //   name: '020001'
  }],
  sxhjyjh: [
    {
      label: 'Career Opportunities',
      name: '030001'
    }
  ],
  xygs: [
    {
      name: '040001',
      label: 'Overseas Returnees'
    },
    {
      name: '040002',
      label: 'Background Upgraders'
    },
    {
      name: '040003',
      label: 'Track Changers'
    }
  ],
  xyds: [
    {
      name: '050001',
      label: 'Campus Ambassador'
    }
  ],
  tzy: [
    {
      name: '060001',
      label: 'Internship Challenge'
    }
  ]
}

export default {
  name: 'Article',
  components: {
    ArticleTabs,
    NavBar
  },
  mixins: [common],
  data() {
    return {
      active: '',
      tabData: []
    }
  },
  // computed: {
  //   lang() {
  //     return this.$store.getters.language
  //   }
  // },
  watch: {
    '$route': {
      handler(val) {
        const { cat } = val.params
        this.active = cat
        if (this.lang === 'en') {
          this.tabData = enCatTypes[this.active]
        } else {
          this.tabData = zhCatTypes[this.active]
        }
      }
    }
  },
  mounted() {
    // this.lang = this.$store.getters.language
    this.active = this.$route.params.cat
    if (this.lang === 'en') {
      this.tabData = enCatTypes[this.active]
    } else {
      this.tabData = zhCatTypes[this.active]
    }
  }
}
</script>

<style>
</style>
